import { render, staticRenderFns } from "./i-notify.vue?vue&type=template&id=5e412216&scoped=true&"
import script from "./i-notify.vue?vue&type=script&lang=js&"
export * from "./i-notify.vue?vue&type=script&lang=js&"
import style0 from "./i-notify.vue?vue&type=style&index=0&id=5e412216&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e412216",
  null
  
)

export default component.exports